module.exports = {
	defaultTitle: 'BuiltByBrayne',
	logo: 'https://builtbybrayne.com/builtbybrayne_logo.png',
	author: 'BuiltByBrayne',
	url: 'https://builtbybrayne.com',
	legalName: 'A Better World Ltd',
	defaultDescription: 'Building apps for positive social change',
	socialLinks: {
		// twitter: 'http://www.twitter.com/smakosh',
		// github: 'https://github.com/perchten',
		linkedin: 'https://www.linkedin.com/in/albrayne/',
		// instagram: 'https://instagram.com/smakosh19',
		// youtube: 'https://www.youtube.com/user/smakoshthegamer',
		// google: 'https://plus.google.com/u/0/+IsmailSmakoshGhallou',
	},
	googleAnalyticsID: 'UA-149148471-1',
	themeColor: '#FFD500',
	backgroundColor: '#FF7600',
	social: {
		// facebook: 'appId',
		// twitter: '@smakosh',
	},
	address: {
		city: 'Bristol',
		region: 'Region',
		country: 'UK',
		zipCode: 'BS5 6DG',
	},
	contact: {
		email: 'al@builtbybrayne.com',
		phone: '+44(0)77779266625',
	},
	foundingDate: '2014',
	recaptcha_key: '6Lf1T7sUAAAAAAotlSD8z46Cw3dnp6-yHQlw2CjG',
	forms: {
		contact: "builtbybrayne-contact-form"
	}
};
